import { supabase } from "../lib/supabase";

export type ReviewStage = "gmr" | "line";
export type ReviewDecision = "approved" | "observed";

export interface ValidationQueueItem {
  validationId: string;
  versionId: string;
  versionNumber: number;
  submittedAt: string;
  centerCode: string;
  centerName: string;
  taskId: string;
  taskCode: string;
  taskName: string;
  activityCode: string;
  activityName: string;
  unit: string;
  values: number[];
  gmrCode: string;
  justification: string;
  lineCode: string | null;
  lineName: string | null;
  gmrStatus: "pending" | "approved" | "observed";
  lineStatus: "waiting" | "pending" | "approved" | "observed" | "not_required";
  gmrComment: string | null;
  lineComment: string | null;
  reviewStage: ReviewStage | null;
}

interface QueueRow {
  validation_id: string;
  version_id: string;
  version_number: number;
  submitted_at: string;
  center_code: string;
  center_name: string;
  task_id: string;
  task_code: string;
  task_name: string;
  activity_code: string;
  activity_name: string;
  unit: string;
  values: Array<number | string>;
  gmr_code: string;
  line_code: string | null;
  justification: string;
  line_name: string | null;
  gmr_status: ValidationQueueItem["gmrStatus"];
  line_status: ValidationQueueItem["lineStatus"];
  gmr_comment: string | null;
  line_comment: string | null;
  review_stage: ReviewStage | null;
}

function requireClient() {
  if (!supabase) throw new Error("Supabase no está configurado.");
  return supabase;
}

export async function loadValidationQueue(cycleId: string): Promise<ValidationQueueItem[]> {
  const client = requireClient();
  const { data, error } = await client.rpc("load_validation_queue", { p_cycle_id: cycleId });
  if (error) throw error;
  return ((data ?? []) as QueueRow[]).map((row) => ({
    validationId: row.validation_id,
    versionId: row.version_id,
    versionNumber: row.version_number,
    submittedAt: row.submitted_at,
    centerCode: row.center_code,
    centerName: row.center_name,
    taskId: row.task_id,
    taskCode: row.task_code,
    taskName: row.task_name,
    activityCode: row.activity_code,
    activityName: row.activity_name,
    unit: row.unit,
    values: row.values.map(Number),
    gmrCode: row.gmr_code,
    lineCode: row.line_code,
    lineName: row.line_name,
    gmrStatus: row.gmr_status,
    lineStatus: row.line_status,
    gmrComment: row.gmr_comment,
    justification: row.justification,
    lineComment: row.line_comment,
    reviewStage: row.review_stage,
  }));
}

export async function reviewTaskValidation(validationId: string, stage: ReviewStage, decision: ReviewDecision, comment: string) {
  const client = requireClient();
  const { error } = await client.rpc("review_task_validation", {
    p_validation_id: validationId,
    p_stage: stage,
    p_decision: decision,
    p_comment: comment.trim() || null,
  });
  if (error) throw error;
}
